<template>
  <div class="task-form p-3">
    <div class="row">
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="taskTitle" class="form-label">
              Task Title <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              id="taskTitle"
              class="form-control"
              placeholder="Enter task title"
              v-model="taskData.title"
              required
            />
            <div class="text-danger" v-if="errors.task_title">
              {{ errors.task_title[0] }}
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <label for="taskDescription" class="form-label"
              >Task Description</label
            >
            <textarea
              id="taskDescription"
              class="form-control"
              placeholder="Task Description"
              v-model="taskData.description"
              rows="4"
            ></textarea>
            <div class="text-danger" v-if="errors.task_description">
              {{ errors.task_description[0] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="taskType" class="form-label">
              Type <span class="text-danger">*</span>
            </label>
            <select
              v-model="taskData.taskType"
              id="taskType"
              class="form-select"
              required
            >
              <option value="Log a Call">Log a Call</option>
              <option value="Log an E-mail">Log an E-mail</option>
              <option value="Log a Meeting">Log a Meeting</option>
              <option value="Visit Log">Visit Log</option>
              <option value="WhatsApp">WhatsApp</option>
            </select>
            <div class="text-danger" v-if="errors.type">
              {{ errors.type[0] }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="startDate" class="form-label"
              >Start Date <span class="text-danger">*</span></label
            >
            <input
              type="date"
              v-model="taskData.startDate"
              id="startDate"
              class="form-control"
            />
            <div class="text-danger" v-if="errors.start_date">
              {{ errors.start_date[0] }}
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="startTime" class="form-label"
              >Time <span class="text-danger">*</span></label
            >
            <input
              type="time"
              v-model="taskData.startTime"
              id="startTime"
              class="form-control"
            />
            <div class="text-danger" v-if="errors.start_time">
              {{ errors.start_time[0] }}
            </div>
          </div>

          <div class="col-md-3 mb-3">
            <label for="dueDate" class="form-label">
              End Date <span class="text-danger">*</span>
            </label>
            <input
              type="date"
              v-model="taskData.dueDate"
              id="dueDate"
              class="form-control"
              required
            />
            <div class="text-danger" v-if="errors.due_date">
              {{ errors.due_date[0] }}
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="dueTime" class="form-label"
              >End Time <span class="text-danger">*</span></label
            >
            <input
              type="time"
              v-model="taskData.dueTime"
              id="dueTime"
              class="form-control"
            />
            <div class="text-danger" v-if="errors.due_time">
              {{ errors.due_time[0] }}
            </div>
          </div>
        </div>

        <div
          v-for="(reminder, i) in taskData.reminders"
          :key="i"
          class="row align-items-center"
        >
          <div class="col-md-5 mb-3">
            <label :for="`reminderDate${i}`" class="form-label">
              Reminder Date
            </label>
            <input
              type="date"
              v-model="reminder.reminderDate"
              :id="`reminderDate${i}`"
              class="form-control"
            />
          </div>
          <div class="col-md-5 mb-3">
            <label :for="`reminderTime${i}`" class="form-label"
              >Reminder Time</label
            >
            <input
              type="time"
              v-model="reminder.reminderTime"
              :id="`reminderTime${i}`"
              class="form-control"
            />
          </div>
          <div class="col-md-2 mb-3 d-flex align-items-start">
            <div class="w-100">
              <label class="form-label invisible">Actions</label>
              <button
                v-if="i === taskData.reminders.length - 1"
                @click="addReminder"
                class="btn btn-success btn-icon me-2"
                title="Add Reminder"
              >
                <i class="fas fa-plus"></i>
              </button>
              <button
                v-if="taskData.reminders.length > 1"
                @click="removeReminder(i)"
                class="btn btn-danger btn-icon"
                title="Remove Reminder"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="assignTo" class="form-label">Assign To</label>
            <multiselect
              v-model="taskData.assignTo"
              :options="formatAssignTo"
              track-by="id"
              label="name"
              :multiple="true"
              placeholder="Select Assign To"
            >
            </multiselect>
            <div class="text-danger" v-if="errors.assign_to">
              {{ errors.assign_to[0] }}
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="priority" class="form-label">
              Priority <span class="text-danger">*</span>
            </label>
            <select
              v-model="taskData.priority"
              id="priority"
              class="form-select"
              required
            >
              <option value="normal">Normal</option>
              <option value="high">High</option>
              <option value="low">Low</option>
            </select>
            <div class="text-danger" v-if="errors.priority">
              {{ errors.priority[0] }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="attachments" class="form-label"
              >Attachments Doc/Media</label
            >
            <div class="d-grid">
              <label class="btn btn-outline-primary">
                <i class="fas fa-upload"></i>
                Add New
                <input
                  type="file"
                  id="attachments"
                  class="d-none"
                  @change="handleFileUpload"
                />
              </label>
              <div class="text-danger" v-if="errors.attachments">
                {{ errors.attachments[0] }}
              </div>
            </div>
            <div v-if="taskData.file" class="mt-2 text-muted">
              <small
                ><strong>Selected File:</strong> {{ taskData.file.name }}</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 mt-3">
    <div class="d-flex justify-content-end">
      <button class="btn btn-success" @click="saveTask">
        <span v-if="!isLoading">Save Task</span>
        <span v-else>Loading...</span>
      </button>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    leadId: {
      type: String,
      required: true,
    },
    initialInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,

      taskData: {
        title: "",
        description: "",
        taskType: "",
        startDate: "",
        startTime: "",
        dueDate: "",
        dueTime: "",
        reminders: [
          {
            reminderDate: "",
            reminderTime: "",
          },
        ],
        assignTo: [],
        priority: "",
        file: "",
      },

      errors: {},
    };
  },
  mounted() {
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath = lastPart;
  },
  computed: {
    formatAssignTo() {
      const employees = [];

      this.initialInfo.exhibitions.forEach((exhibition) => {
        if (exhibition.employee_id) {
          employees.push({
            id: exhibition.employee_id.id,
            name: exhibition.employee_id.name,
            email: exhibition.employee_id.email,
          });
        }
      });

      // Remove duplicates
      const uniqueEmployees = Array.from(
        new Map(employees.map((emp) => [emp.id, emp])).values()
      );

      return uniqueEmployees;
    },
  },
  methods: {
    addReminder() {
      this.taskData.reminders.push({ reminderDate: "", reminderTime: "" });
    },
    removeReminder(index) {
      if (this.taskData.reminders.length > 1) {
        this.taskData.reminders.splice(index, 1);
      }
    },

    handleFileUpload(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.taskData.file = selectedFile;
      }
    },

    async saveTask() {
      this.isLoading = true;
      const endpoint = "/store-leads-details-task-info";
      const method = "post";

      const formData = new FormData();
      formData.append("lead_id", this.leadId);
      formData.append("task_title", this.taskData.title);
      formData.append("task_description", this.taskData.description);
      formData.append("type", this.taskData.taskType);
      formData.append("start_date", this.taskData.startDate);
      formData.append("start_time", this.taskData.startTime);
      formData.append("due_date", this.taskData.dueDate);
      formData.append("due_time", this.taskData.dueTime);
      formData.append("priority", this.taskData.priority);
      formData.append(
        "key_account",
        this.currentPath == "key-account-details" ? "Y" : "N"
      );

      formData.append("reminders", JSON.stringify(this.taskData.reminders));

      formData.append("assign_to", JSON.stringify(this.taskData.assignTo));

      if (this.taskData.file) {
        formData.append("attachments", this.taskData.file);
      }

      try {
        const response = await http[method](endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.$emitter.emit("form-submitted");
        this.$toast.success(response.data.message);
        this.isLoading = false;
        this.errors = {};
        this.taskData = {
          title: "",
          description: "",
          taskType: "",
          startDate: "",
          startTime: "",
          dueDate: "",
          dueTime: "",
          reminders: [
            {
              reminderDate: "",
              reminderTime: "",
            },
          ],
          assignTo: [],
          priority: "",
          file: "",
        };
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>
.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  padding: 0;
}
</style>
